import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CargaService {
  constructor(private http: HttpClient) {}

  public GetCarga(): Observable<any> {
    const invalid = ['', undefined, 0, NaN];

    const url = `${environment.baseURL}Carga/GetCargas`;

    return this.http.get<any>(url);
  }
}
